import axios from "axios";
import useMeaQuery from "qpr-base/apihooks/useMeaQuery";
import { useAppContext } from "qpr-base/context/AppCtxProvider";
import { useQuery } from "react-query";

const useProjectKPIQueries = () => {
  const ctx = useAppContext();

  const { data, isLoading, error } = useMeaQuery<any[]>(
    `@result=[${ctx.fullModelId}].scorecard(criteria="symbol=\\"L0\\"").childobjects(recursive=1,keepOriginals=1).topelement;
    @result+=@result.childobjects(recursive=1,criteria="typename=\\"Strategic Objective\\" AND accesslevel>0");
    @result+=@result.childobjects(recursive=1,criteria="typename=\\"Perspective\\" AND accesslevel>-1");
    @result;`,
    `id,name,typename,childobjects,parentelementid,scorecard.symbol(as="scorecardsymbol"),scorecard.topelement(as="topelementid"),value(series="JS_ATTR", period="firsforseries",as="translations"),related(relation=parentObjects,as="parentid"),owner,sectors,sector,measure.value(series="JS_ATTR", period="latestforseries"),symbol,scorecardid,accesslevel`,
    "typename,name"
  );

  const { data: roleData, isLoading: roleLoading } = useQuery(
    "userRole",
    async () => {
      const cdata = await axios.get("/workflow/role");
      return cdata?.data?.data;
    }
  );

  const { data: units, isLoading: unitsLoading } = useQuery(
    "settings-units",
    async () => {
      const response = await axios.post("meaquery", {
        query: `[${ctx.fullModelId}].unit`,
        attributes: "id,name",
      });
      return response?.data?.data;
    }
  );

  const { data: valueSettings, isLoading: valueSettingsLoading } = useQuery(
    "settings-valuesettings",
    async () => {
      const response = await axios.post("meaquery", {
        query: `[${ctx.fullModelId}].valuesetting`,
        attributes: "id,name,typename",
      });
      return response?.data?.data;
    }
  );

  return {
    data,
    modelId: ctx.fullModelId,
    isLoading,
    roleData,
    roleLoading,
    valueSettings,
    valueSettingsLoading,
    units,
    unitsLoading,
  };
};

export default useProjectKPIQueries;
